import React, { PropTypes } from 'react';

import { Card, RaisedButton, Toggle } from 'material-ui';
import Icon from '../tc-ui/icon';

const PlanDetails = ({ plan, companyType, productType, onUpgradeClick, onTermClick, isAnnualPlan }) => {
  const priceNode = typeof plan.price === 'string'
  ? <span style={{ display: 'inline-block', fontSize: '50px' }}>{plan.price === 'Custom' ? 'Contact Us' : plan.price }</span>
  : <span style={{ display: 'inline-block', fontSize: '72px' }}>{plan.price}<span style={{ fontSize: '18px', lineHeight: 0, verticalAlign: 'top' }}>USD</span></span>;
  return (
    <Card style={{ width: '75%', margin: '0 auto', padding: '20px' }}>
      <h2 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '0', textTransform: 'uppercase', color: 'rgb(255, 39, 104)', letterSpacing: '2px', textAlign: 'center', padding: 0 }}>{plan.name} Plan</h2>
      { plan.price !== 'Custom'
        ? <p style={{ margin: 0, padding: 0, textAlign: 'center', textTransform: 'uppercase', verticalAlign: 'top' }}>Billed {plan.term === 'month' ? 'monthly' : 'annually'}</p> :
        <p style={{ margin: 0, padding: 0, textAlign: 'center', textTransform: 'uppercase', verticalAlign: 'top' }}>large volume contracting</p>
      }
      <br/>
      <div style={{ margin: '0 auto', textAlign: 'center', width: '100%' }}>
        <div style={{ display: 'inline-block', width: '50%', verticalAlign: 'middle' }}>
          {
            companyType === 'Supplier' ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                  {priceNode}<span>base price (incl. 1 {productType === 'Non-Accommodation' ? 'location' : 'property'})</span>
                </div>
                <span style ={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                  ${plan.additional} USD per additional {productType === 'Non-Accommodation' ? 'location' : 'property'}
                </span>
              </div>
            ) : priceNode
          }
        </div>
        <div style={{ display: 'inline-block', margin: '0 auto', verticalAlign: 'middle', width: '50%' }}>
            <h1 style={{ fontWeight: 400, fontSize: '20px', lineHeight: '36px', margin: 0, textAlign: 'center' }}>Get more out of your B2B relationship</h1>
            <p style={{ fontWeight: 300, fontSize: '12px', lineHeight: '24px', margin: 0, padding: 0, textAlign: 'justify' }}>
              By upgrading your account, you will get full access to search and connect with new partners, partner management tools, marketing materials and more.
            </p>
        </div>
        {/* {plan.price !== 'Custom' ? <RaisedButton label="Upgrade Now" primary style={{ margin: '25px 10px 10px 10px' }} onClick={onUpgradeClick} />
      : <RaisedButton label="Send Us A Message" primary style={{ margin: '25px 10px 10px 10px' }} onClick={() => window.Intercom('showNewMessage', 'I\'d like to get more details on the enterprise plan')}/>
        } */}
      </div>
      {
        plan.price !== 'Custom' && <Toggle
          label={<span>Pay annually and <strong>save 17%</strong></span>}
          labelPosition="right"
          labelStyle={{ width: 'auto' }}
          style={{ display: 'inline-block', padding: '0 10px', width: 'auto' }}
          toggled={isAnnualPlan}
          onClick={onTermClick}
        />
      }
    </Card>
  );
};

PlanDetails.propTypes = {
  plan: PropTypes.object,
  companyType: PropTypes.string,
  onUpgradeClick: PropTypes.func,
};

export default PlanDetails;



// WEBPACK FOOTER //
// ./src/app/components/upgrade/PlanDetails.jsx